import { render, staticRenderFns } from "./manualRuleEditor.vue?vue&type=template&id=d366abae&scoped=true&"
import script from "./manualRuleEditor.vue?vue&type=script&lang=js&"
export * from "./manualRuleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d366abae",
  null
  
)

export default component.exports